/**
 * Utility functions for processing and managing documents
 */

/**
 * Extract documents from the docs array in API response
 * @param {Array} docsArray - Array of document objects from API
 * @returns {Object} Object containing panDocument, aadhaarDocument, and their info
 */
export const extractDocumentsFromArray = (docsArray) => {
  let panDocument = null;
  let aadhaarDocument = null;
  let panDocumentInfo = null;
  let aadhaarDocumentInfo = null;

  if (!docsArray || !Array.isArray(docsArray)) {
    console.log('No docs array found or docs is not an array:', docsArray);
    return { panDocument, aadhaarDocument, panDocumentInfo, aadhaarDocumentInfo };
  }

  console.log('Processing docs array:', docsArray);
  
  docsArray.forEach((doc, index) => {
    console.log(`Processing doc ${index}:`, doc);
    
    if (doc.file === 'PAN Card' && doc.data) {
      try {
        const docData = JSON.parse(doc.data);
        console.log('PAN docData:', docData);
        
        if (docData.base64) {
          panDocument = docData.base64;
          panDocumentInfo = {
            name: docData.name || 'PAN Document',
            size: docData.size || 0,
            type: docData.name ? docData.name.split('.').pop() : 'jpg'
          };
          console.log('PAN document set successfully');
        }
      } catch (error) {
        console.error('Error parsing PAN document data:', error);
      }
    } else if (doc.file === 'Aadhaar Card' && doc.data) {
      try {
        const docData = JSON.parse(doc.data);
        console.log('Aadhaar docData:', docData);
        
        if (docData.base64) {
          aadhaarDocument = docData.base64;
          aadhaarDocumentInfo = {
            name: docData.name || 'Aadhaar Document',
            size: docData.size || 0,
            type: docData.name ? docData.name.split('.').pop() : 'jpg'
          };
          console.log('Aadhaar document set successfully');
        }
      } catch (error) {
        console.error('Error parsing Aadhaar document data:', error);
      }
    } else {
      console.log(`Document ${index} doesn't match expected file types. File: "${doc.file}"`);
    }
  });

  return { panDocument, aadhaarDocument, panDocumentInfo, aadhaarDocumentInfo };
};

/**
 * Format file size in human readable format
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (!bytes) return '0 KB';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

/**
 * Get file extension from filename
 * @param {string} filename - The filename
 * @returns {string} File extension
 */
export const getFileExtension = (filename) => {
  if (!filename) return 'unknown';
  return filename.split('.').pop().toLowerCase();
};

/**
 * Validate if base64 string is a valid image
 * @param {string} base64String - Base64 encoded string
 * @returns {boolean} True if valid image
 */
export const isValidImageBase64 = (base64String) => {
  if (!base64String) return false;
  
  // Check if it starts with data:image/
  if (base64String.startsWith('data:image/')) {
    return true;
  }
  
  // Check if it's a valid base64 string
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
  return base64Regex.test(base64String);
};

/**
 * Get document type icon
 * @param {string} documentType - Type of document (PAN, Aadhaar, etc.)
 * @returns {string} Icon emoji
 */
export const getDocumentIcon = (documentType) => {
  switch (documentType.toLowerCase()) {
    case 'pan':
      return '🆔';
    case 'aadhaar':
      return '🆔';
    case 'passport':
      return '📘';
    case 'driving':
      return '🚗';
    default:
      return '📄';
  }
};
